<template>
  <div class="no-notifications-container">
    <div class="icon-container">
      <BellIcon class="icon-i-500 notification-bell-icon" />
    </div>
    <span class="h3 grey-900 mb-16">
      {{ $t('There is nothing to catch up') }}
    </span>
    <span class="text-small grey-600">
      {{ $t('When someone updates a project or tender you follow, you’ll be notifed here.') }}
    </span>
  </div>
</template>

<script>
  import BellIcon from '@/assets/icons/bell.svg';

  export default {
    name: 'NoNotifications',
    components: {
      BellIcon,
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .no-notifications-container {
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .icon-container {
      display: flex;
      align-items: center;
      justify-content: center;

      background: $primary50;
      border-radius: 60px;
      width: 192px;
      height: 192px;

      margin-bottom: 32px;
    }
  }

  .notification-bell-icon {
    min-width: 96px;
    min-height: 106px;
  }
</style>
